<template>
    <div class="c-section box-sh">
        <div class="o-bk-date-selection is-rounded" id="date-selector">
            <button class="o-bk-date-selection__control is-prev" type="button">
                <span class="icon-chevron-left"></span>
            </button>

            <button class="o-bk-date-selection__control is-next" type="button">
                <span class="icon-chevron-left"></span>
            </button>

            <ul class="o-bk-date-selection__list text-center">
                <li v-for="(day, index) in calendar" v-bind:key="index" class="swiper-slide-item" :class="{
                    'swiper-slide-active': day.price && day.date.format('YYYY-MM-DD') == legs.out.date
                    }">
                    <div class="o-bk-date-selection__item" :class="{
                        'not-available': ! day.price,
                        'selected': day.price && day.date.format('YYYY-MM-DD') == legs.out.date,
                        }">
                        <strong class="is-year">{{day.date.format('DD MMM')}}</strong>
                        
                        <p class="mt-1 mb-2 fs-14 cl-dark">{{day.date.format('dddd')}}</p>
                        
                        <strong class="fs-20" v-if="day.price">{{ currency(day.price) }}</strong>
                        
                        <span class="icon-forbidden fs-18" v-else></span>
                    </div>

                    <button class="o-bk-date-selection__btn" v-if="day.price > 0" @click="onDateClicked(day.date)"></button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    props: {
        prices: {
            type: Object,
            default() {
                return {
                    out: [],
                    ret: [],
                }
            }
        },
    },
    data() {
        return {
            slider: null,
        }
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'ticket',
        ]),
        selectedDate() {
            return this.legs.out.date
        },
        calendar() {
            let date = moment(this.legs.out.date).subtract(7, 'days')
            if (date.isSameOrBefore(moment())) {
                date = moment().add(1, 'days').startOf('day')
            }
            let end = moment(date).add(14, 'days')

            let calendar = []

            while (date.isSameOrBefore(end)) {
                let outPrice = this.prices.out.find(price => price.date == date.format('YYYY-MM-DD'))
                let retPrice = this.prices.ret.find(price => price.date == date.format('YYYY-MM-DD'))
                
                calendar.push({
                    date: moment(date),
                    price: (outPrice && retPrice) ? parseFloat(outPrice.price) + parseFloat(retPrice.price) : null,
                })

                date.add(1, 'day')
            }
        
            return calendar
        },
    },
    watch: {
        prices() {
            this.slider.update()
            this.setActiveSlide()
        },
        selectedDate() {
            this.setTrip({
                trip: null,
                leg: 'out',
            })
            this.setTrip({
                trip: null,
                leg: 'ret',
            })
            this.$store.commit('setQuote', null)
        }
    },
    mounted() {
        let el = '#date-selector'
        this.slider = new Swiper(el, {
            slidesPerView: 2,
            navigation: {
                nextEl: el + ' .is-next',
                prevEl: el + ' .is-prev',
            },
            slideClass: 'swiper-slide-item',
            wrapperClass: 'o-bk-date-selection__list',
            slidesPerGroup: 1,
            breakpoints: {
                468: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 5,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                }
            }
        })
        this.setActiveSlide()
        this.getQuote()
    },
    methods: {
        ...mapActions('booking', [
            'getQuote'
        ]),
        ...mapMutations('booking', [
           'setDate',
           'setTrip',
        ]),
        onDateClicked(date) {
            this.setDate({ date: date.format('YYYY-MM-DD'), leg: 'out' })
            this.setDate({ date: date.format('YYYY-MM-DD'), leg: 'ret' })
        },
        setActiveSlide() {
            let dateIndex = this.calendar.findIndex(day => day.date.format('YYYY-MM-DD') == this.legs.out.date)
            this.slider.slideTo(dateIndex)
        }
    }
}
</script>